import NotificationCenter from './components/PopoverPages/NotificationCenter';
import SettingsCenter from './components/PopoverPages/SettingsCenter';
import EventsFilters from './components/PopoverPages/EventsFiltersPopover';

export const popoverWidgets = [
  {
    id: 'notifications',
    nameMessage: 'Notifications',
    component: NotificationCenter
  },
  {
    id: 'settings',
    nameMessage: 'Settings',
    component: SettingsCenter
  },
  {
    id: 'events/filters',
    nameMessage: 'Event Filters',
    component: EventsFilters
  }
];
